import cookieManager from '../common/cookieManager'
import utils from '../common/utils'
import { clearH5Bind } from '../common/h5BindStore'

export default {
  state: {
    token: '',
    userimg: '',
    username: '',
    themeAside: null
  },
  mutations: {
    //写入用户token秘钥（加密后存储）
    setToken(state, val) {
      state.token = val
      const encryptedToken = utils.encryptKey(val)
      cookieManager.set('token', encryptedToken)
    },
    //清除当前用户存储的token秘钥，退出登录
    clearToken(state) {
      state.token = ""
      state.equser = []
      state.username = ""
      cookieManager.remove('token')
      cookieManager.remove('userimg')
      cookieManager.remove('username')
      clearH5Bind()
    },
    //获取到客户端存储的用户token秘钥（获取时解密）
    getToken(state) {
      const encryptedToken = cookieManager.get('token')
      if (encryptedToken) {
        state.token = utils.decryptKey(encryptedToken)
      }
    },
    //写入用户的基础信息
    setUserimg(state, val) {
      state.userimg = val
      cookieManager.set('userimg', val)
    },
    //获取到客户端存储的用户信息
    getUserimg(state) {
      state.userimg = state.userimg || cookieManager.get('userimg')
    },
    //写入用户名
    setUsername(state, val) {
      state.username = val
      cookieManager.set('username', val)
    },
    //获取到客户端存储的用户名
    getUsername(state) {
      state.username = state.username || cookieManager.get('username')
    },
    // 设置侧边栏主题到state
    setThemeAside(state, theme){
      state.themeAside = theme
      try{ localStorage.setItem('theme.aside', JSON.stringify(theme || {})) }catch(e){}
    }
  }
}
